import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { TabLabelsWrapper, CurrentTabIndicator } from './style';

class TabNavigation extends PureComponent {
  renderTabButton = (tabIndex, label, componentData) => {
    const { selectedTabIndex, updateTabIndex, TabButtonComponent } = this.props;

    return (
      <TabButtonComponent
        key={`tab-${tabIndex}`}
        {...componentData}
        className={tabIndex === selectedTabIndex ? 'active' : ''}
        onClick={() => updateTabIndex(tabIndex)}
      >
        <Typography
          variant="subtitle"
          tag="span"
        >
          {label}
        </Typography>
      </TabButtonComponent>
    );
  };

  render() {
    const {
      labelsArray,
      selectedTabIndex,
      tabButtonComponentData,
    } = this.props;

    const tabIndicatorWidth = 100 / labelsArray.length;
    return (
      <>
        <TabLabelsWrapper>
          {labelsArray.map((label, i) => this.renderTabButton(i, label, tabButtonComponentData[i]))}
        </TabLabelsWrapper>
        <CurrentTabIndicator
          width={tabIndicatorWidth}
          offset={selectedTabIndex}
        />
      </>
    );
  }
}

TabNavigation.defaultProps = {
  TabButtonComponent: props => <button type="button" {...props} />,
  updateTabIndex: () => {},
  tabButtonComponentData: [],
};

TabNavigation.propTypes = {
  TabButtonComponent: PropTypes.elementType,
  labelsArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedTabIndex: PropTypes.number.isRequired,
  tabButtonComponentData: PropTypes.arrayOf(PropTypes.any),
  updateTabIndex: PropTypes.func,
};

export default TabNavigation;
